import React from 'react';
import {navigateHook} from "../../hooks/use-navigate.js";

const AgGridLinkCellRenderer = ({data, value, valueFormatted, getUrls, openNewTabOnClick = false}) => {
    const navigate = navigateHook();
    const content = valueFormatted ?? value ?? "";

    if (!data || !getUrls) {
        return content;
    }

    const {urlDev} = getUrls(data);

    if (!urlDev) {
        return content;
    }

    const onClick = (event) => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        navigate(urlDev, openNewTabOnClick);
    }

    return (
        <a
            onClick={onClick}
            className="block h-full w-full text-current no-underline"
        >
            {content}
        </a>
    );
}

export default AgGridLinkCellRenderer;
